import React, { useEffect, useRef } from "react";

export function ContextMenu({ x, y, items, onClose }) {
    const ref = useRef(null);

    useEffect(() => {
        // Adjust so menu doesn't overflow viewport
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const el = ref.current;
            if (rect.right > window.innerWidth) {
                el.style.left = `${x - rect.width}px`;
            }
            if (rect.bottom > window.innerHeight) {
                el.style.top = `${y - rect.height}px`;
            }
        }
    }, [x, y]);

    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose();
        };
        const handleKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("mousedown", handleClick);
        document.addEventListener("keydown", handleKey);
        return () => {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("keydown", handleKey);
        };
    }, [onClose]);

    return (
        <ul
            ref={ref}
            role="menu"
            style={{
                position: "fixed",
                top: y,
                left: x,
                zIndex: 9999,
                background: "#ffffff",
                border: "1px solid #e0e0e0",
                borderRadius: 8,
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                minWidth: 150,
                padding: "4px 0",
                margin: 0,
                listStyle: "none",
                userSelect: "none",
            }}
        >
            {items.map((item) => (
                <li
                    key={item.label}
                    role="menuitem"
                    tabIndex={0}
                    onClick={() => {
                        item.onClick();
                        onClose();
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            item.onClick();
                            onClose();
                        }
                    }}
                    style={{
                        padding: "9px 16px",
                        cursor: "pointer",
                        fontSize: 14,
                        color: item.danger ? "#d32f2f" : "#333",
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        transition: "background 0.1s",
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                    }
                >
                    {item.icon && (
                        <span style={{ fontSize: 15, lineHeight: 1 }}>{item.icon}</span>
                    )}
                    {item.label}
                </li>
            ))}
        </ul>
    );
}